import React, { useContext } from 'react';

import WidgetContext from '@totem/components/customDashboard/home/widgets/WidgetContext';
import DeviceSoftwareEndOfSupportContainer from '@totem/components/devices/softwareEndOfLife/summary/DeviceSoftwareEndOfSupportContainer';
import PastEndOfLifeReport from '@totem/components/devices/softwareEndOfLife/summary/PastEndOfLifeReport';
import RecordCountBadge from '@totem/components/ui_components/widgets/RecordCountBadge';

const WidgetEndOfSupportReport = () => {
  const { onSetTitle, componentInstance } = useContext(WidgetContext);

  return (
    <DeviceSoftwareEndOfSupportContainer
      onRecordTotalChanged={(recordCount: number) =>
        onSetTitle(<RecordCountBadge count={recordCount} />)
      }
    >
      <PastEndOfLifeReport
        componentKey={`${componentInstance.title}_${componentInstance.componentInstanceId}`}
      />
    </DeviceSoftwareEndOfSupportContainer>
  );
};

export default WidgetEndOfSupportReport;
